import { FallbackProps } from 'react-error-boundary';

export const ErrorFallBack = ({ error }: FallbackProps) => {
  console.log({ error });
  return <div>Something went wrong: {error.message ?? JSON.stringify(error)}</div>;
};
